import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prg-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.less']
})
export class StartComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  isActive(name: string): boolean {
    return (window.location.href.indexOf(name) >= 0);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/start/start.component.ts